export default __webpack_public_path__ + "static/media/03_photo.aa5df376.jpeg";